import { List } from 'immutable';

import { mkBiller } from './billersTypes';

const transformApiDataToBiller = ({ providerBillerID, ...otherProps }) =>
  mkBiller({ id: providerBillerID, ...otherProps });

export const transformResponseToBillers = (response) =>
  response.data.resources.slice(0, 15).map(transformApiDataToBiller);

export const transformResponseToBiller = ({ data }) => transformApiDataToBiller(data);

export const transformSearchResponseToBillers = (response) =>
  List(response.data.resources.map(transformApiDataToBiller));
